// src/components/sat/ProgressGauge.js
//
// Circular completion gauge used for the OVERALL plan progress shown near the
// top of plan cards / detail / the tutor Prepare card. (Subject/category bars
// and the session progress sliders intentionally stay as bars.)

import React from "react";

export default function ProgressGauge({ percent = 0, size = 72, stroke = 8, color = "#059669", track = "#e2e8f0", showLabel = true }) {
  const p = Math.max(0, Math.min(100, Math.round(Number(percent) || 0)));
  const r = (size - stroke) / 2;
  const cx = size / 2;
  const c = 2 * Math.PI * r;
  const offset = c * (1 - p / 100);
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} style={{ flexShrink: 0 }} role="img" aria-label={`${p}% complete`}>
      <circle cx={cx} cy={cx} r={r} fill="none" stroke={track} strokeWidth={stroke} />
      <circle
        cx={cx}
        cy={cx}
        r={r}
        fill="none"
        stroke={color}
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeDasharray={c}
        strokeDashoffset={offset}
        transform={`rotate(-90 ${cx} ${cx})`}
        style={{ transition: "stroke-dashoffset 300ms ease" }}
      />
      {showLabel && (
        <text
          x="50%"
          y="50%"
          dominantBaseline="central"
          textAnchor="middle"
          style={{ fontSize: size * 0.26, fontWeight: 800, fill: "#0f172a" }}
        >
          {p}%
        </text>
      )}
    </svg>
  );
}
